import { BeatLoader } from 'react-spinners';

const AcademiaModalLoading = () => {
  // rendering academia modal loading component here
  return (
    <div className='flex items-center justify-center h-10'>
      <BeatLoader color='#35476F' size={8} />
    </div>
  );
};

export default AcademiaModalLoading;
